import React, { useRef } from "react";
import axios from "axios";
import "./FormConsulta.css";

import CONFIG from "../../Config";

const URL_SubirForm = `${CONFIG.API_URL}/SubirForm.php`;

const FormularioContacto = () => {
  const nombreRef = useRef();
  const apellidoRef = useRef();
  const telefonoRef = useRef();
  const empresaRef = useRef();
  const contactoRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      nombre: nombreRef.current.value,
      apellido: apellidoRef.current.value,
      telefono: telefonoRef.current.value,
      empresa: empresaRef.current.value,
      contacto: contactoRef.current.value,
    };

    axios.post(URL_SubirForm, formData)
      .then((res) => {
        if (res.data.status) {
          alert("Formulario enviado y guardado correctamente.");
          nombreRef.current.value = "";
          apellidoRef.current.value = "";
          telefonoRef.current.value = "";
          empresaRef.current.value = "";
          contactoRef.current.value = "";
        } else {
          alert("Error al guardar: " + res.data.message);
          alert(res.data)
        }
      })
      .catch((error) => {
        console.error("Error al enviar:", error);
        alert("No se pudo conectar con el servidor.");
      });
  };

  return (
    <div className="Padretodo">
      <div className="formularr">
        <h2 className="tituloi">Formulario de Contacto</h2>
      </div>
      <div className="contenedor_formulario">
        <form onSubmit={handleSubmit} className="formulario">
          <label>Nombre:</label>
          <input type="text" name="nombre" ref={nombreRef} required />

          <label>Apellido:</label>
          <input type="text" name="apellido" ref={apellidoRef} required />

          <label>Teléfono:</label>
          <input type="tel" name="telefono" ref={telefonoRef} required />

          <label>Empresa o rubro a dedicar:</label>
          <input type="text" name="empresa" ref={empresaRef} />

          <label>Día y horario de contacto:</label>
          <input type="date" name="contacto" ref={contactoRef} required />

          <button type="submit">Enviar</button>
        </form>
      </div>
    </div>
  );
};

export default FormularioContacto;
